export default __webpack_public_path__ + "static/media/real_properties.e37488a6.svg";